import { memo } from "react"

const AddonCard = ({ addon, index, handleShowConfirm }) => {
    return (
        <div
            className="col-md-4 col-lg-3"
            key={"myAddOn-" + index}
        >
            <div className="add-on-card">
                <div className="ao-card-header">
                    <p>{addon?.AddonInfoName} </p>
                    <button
                        className="cx-btn-2"
                        onClick={() => handleShowConfirm(addon)}
                    >
                        {addon.IsActive ? 'Enable' : 'Disable'}
                    </button>
                </div>
                <div className="ao-card-table-wrapper">
                    <table className="ao-card-table">
                        <thead className="ao-card-head">
                            <tr>
                                <th>Monthly Subscription</th>
                                {/* <th>Next Renewal</th> */}
                            </tr>
                        </thead>
                        <tbody className="ao-card-body">
                            <tr>
                                <td>{addon?.AddonInfoPrice}</td>
                                {/* <td>Jan 01, 2025</td> */}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default memo(AddonCard)